export const FETCH_DIET = {
  START: 'START_FETCH_DIET',
  COMPLETE: 'COMPLETE_FETCH_DIET',
  FAIL: 'FAIL_FETCH_DIET',
  CLEANUP: 'CLEANUP_FETCH_DIET',
}

export const UPDATE_DIET_SIMPLE_DETAILS = {
  START: 'START_UPDATE_DIET_SIMPLE_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_DIET_SIMPLE_DETAILS',
  FAIL: 'FAIL_UPDATE_DIET_SIMPLE_DETAILS',
}

export const UPDATE_DIET_IMAGE_DETAILS = {
  START: 'START_UPDATE_DIET_IMAGE_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_DIET_IMAGE_DETAILS',
  FAIL: 'FAIL_UPDATE_DIET_IMAGE_DETAILS',
}

export const UPDATE_DIET_EXCLUDED_ALLERGENS_DETAILS = {
  START: 'START_UPDATE_DIET_EXCLUDED_ALLERGENS_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_DIET_EXCLUDED_ALLERGENS_DETAILS',
  FAIL: 'FAIL_UPDATE_DIET_EXCLUDED_ALLERGENS_DETAILS',
}

export const UPDATE_DIET_EXCLUDED_INGREDIENTS_DETAILS = {
  START: 'START_UPDATE_DIET_EXCLUDED_INGREDIENTS_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_DIET_EXCLUDED_INGREDIENTS_DETAILS',
  FAIL: 'FAIL_UPDATE_DIET_EXCLUDED_INGREDIENTS_DETAILS',
}

export const SET_DIET_PAGE_TO_DIRTY = 'SET_DIET_PAGE_TO_DIRTY'
